import { gql } from '@apollo/client';

export const GET_COHORT_PEOPLE_FROM_IDS = gql`
  query GetCohortPeopleFromIds($input: CohortPeopleInput!) {
    people: getCohortPeopleFromIds(input: $input) {
      id
      name
    }
  }
`;
